module.exports = __webpack_public_path__ + "static/headshot-8c67ec870a7be58882aabdea619ab11c.png";